import { Box, Grid, Image, ResponsiveContext, Text } from "grommet";
import { flatten, groupBy } from "lodash";
import * as React from "react";
import { useParams } from "react-router-dom";
import { usePermission } from "../account/AccountStore";
import { AliasCard } from "../aliases/AliasCard";
import { AliasRow } from "../aliases/AliasTable";
import { getLeague, LeagueViewModel } from "../leagues/LeaguesStore";
import { LeagueRow } from "../leagues/LeagueRow";
import { Outcome } from "../matches/OutcomeIcon";
import { StatIcon } from "../stats/StatIcon";
import { TeamName, TeamNameLogo, TeamNameLogoWrapper } from "../teams/TeamName";
import { TeamRow } from "../teams/TeamsManagement";
import { getTeam, TeamViewModel } from "../teams/TeamsStore";
import TeamHeader from "./TeamHeader";
import { SeasonRow } from "../seasons/SeasonRow";
import SkeletonWrapper from "../components/SkeletonWrapper";

const LeagueHome = () => {
    let { id } = useParams<{ id: string }>();

    const [league, setLeague] = React.useState(new LeagueViewModel());
    const [teams, setTeams] = React.useState([] as TeamViewModel[]);

    const [stats, setStats] = React.useState(null as any);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        getLeague(id).then((league) => {
            setLeague(league);
            console.log("interactive");
            setLoading(false);
            // setAllScoresZero(league.participants.every((participant) => participant.outcomes.every((outcome) => outcome.score == 0)));

            // Promise.all(league.participants.map((participant) => getTeam(participant.teamID))).then((teams) => setTeams(teams.map((t) => t.data.result)));
        });
    }, [id]);

    const [allScoresZero, setAllScoresZero] = React.useState(true);

    const size = React.useContext(ResponsiveContext);

    const hasManagementPermission = usePermission("management");

    return (
        <Box align="center">
            <SkeletonWrapper loading={loading}>
                <Box width={{ max: "xxlarge", min: size }} fill gap="small">
                    <LeagueRow league={league} children={<></>} />
                    <Grid columns={size == "small" ? ["auto"] : ["1fr", "2fr"]} gap="small">
                        <Box>{league.logoUri && <Image src={league.logoUri} style={{ maxHeight: "364px", objectFit: "contain" }} />}</Box>
                        <Box gap="small">
                            {league.seasons?.map((season, index) => (
                                <Box key={"mp." + index}>
                                    <SeasonRow season={season} key={index}>
                                        <Box direction="row" gap="small">
                                            {/* {participant.outcomes.map((outcome, outcomeIndex) => (
                                            <Box direction={"row"} gap="small" key={outcome.id}>
                                                {!allScoresZero && (
                                                    <Box direction={"row"} background={"background-front"} pad="small" gap="small" round="10px" align="center">
                                                        <Text>Score {outcome.score}</Text>
                                                    </Box>
                                                )}
                                                <Outcome outcome={outcome} includeText={true} disabled={false}></Outcome>
                                            </Box>
                                        ))}
                                        {participant.outcomes.length == 0 && <Text color={"background-front"}>Not yet played</Text>} */}
                                        </Box>
                                    </SeasonRow>
                                    <Box background={"background"} direction="row" justify="center">
                                        {/* {league.stats.map((s) => (
                                        <Box key={"mp." + index + "." + s.statID} pad="small" justify="center" background={"background"} round="5px">
                                            <Text size="xlarge">
                                                {s.teams.filter((t) => t.teamID == participant.teamID)[0]?.value || "0"} {StatIcon(s.stat)}
                                            </Text>
                                            <Text>{s.stat.name}</Text>
                                        </Box>
                                    ))} */}
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                    {/* <Box pad={{ vertical: "small" }}>
                    {teams.length == 2 && league.participants.length == 2 && (
                        <>
                            <Grid columns={{ size: "auto", count: 2 }} gap="small" fill>
                                <Box fill gap="small">
                                    <Box pad="small" round="5px" background={"background"}>
                                        <TeamNameLogo reverse={false} team={teams[0]} useTeamColor={true}></TeamNameLogo>
                                    </Box>
                                    <Box pad={{ top: "small" }} gap="small" fill direction="row" wrap>
                                        {teams[0].teamMemberships.map((membership) => (
                                            <AliasCard key={membership.id} alias={membership.alias} width={150}></AliasCard>
                                        ))}
                                    </Box>
                                </Box>
                                <Box fill gap="small">
                                    <Box align="end" pad="small" round="5px" background={"background"}>
                                        <TeamNameLogo reverse={true} team={teams[1]} useTeamColor={true}></TeamNameLogo>
                                    </Box>
                                    <Box pad={{ top: "small" }} gap="small" fill direction="row" wrap justify="end">
                                        {teams[1].teamMemberships.map((membership) => (
                                            <AliasCard key={membership.id} alias={membership.alias} width={150}></AliasCard>
                                        ))}
                                    </Box>
                                </Box>
                            </Grid>
                        </>
                    )}
                </Box> */}
                </Box>
            </SkeletonWrapper>
        </Box>
    );
};

export default LeagueHome;
